import ConfigurationManager from "../_configuration/ConfigurationManager";
import HttpMethod from "../_utils/HttpMethod";
import URIBuilder from "../_utils/URIBuilder";

const GENERATE_TOKEN_PATH = "/token";
const PASSWORD_GRANT_TYPE = "password";
const REFRESH_GRANT_TYPE = "refresh_token";

class TokenClient {
  constructor(env) {
    this._env = env;
  }

  async fetchCredentials() {
    try {
      let headers = new Headers();

      let configuration = {
        method: HttpMethod.POST,
        headers,
        body: "",
      };

      let uri = new URIBuilder(
        ConfigurationManager.getProperty("KEY_API_HOST")
      );

      uri.path = ConfigurationManager.getProperty("KEY_API_BASE_PATH");

      let request = new Request(uri.toString(), configuration);
      
      const creds = await fetch(request).then((res) => res.json());

      return Buffer.from(creds, "base64").toString("utf8").split(":");
    } catch (err) {
      window.alert(err);
      console.error(err);

      throw err;
    }
  }

  async generateToken(userName, password) {
    const [CLIENT_ID, CLIENT_SECRET] = await this.fetchCredentials();

    let headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append(
      "AppID",
      ConfigurationManager.getProperty("TOKEN_API_APP_ID")
    );

    let body = "";
    body += `username=${encodeURIComponent(userName)}&`;
    body += `password=${encodeURIComponent(password)}&`;
    body += `grant_type=${encodeURIComponent(PASSWORD_GRANT_TYPE)}&`;
    body += `client_id=${encodeURIComponent(CLIENT_ID)}&`;
    body += `client_secret=${encodeURIComponent(CLIENT_SECRET)}`;

    let configuration = {};
    configuration.method = HttpMethod.POST;
    configuration.headers = headers;
    configuration.body = body;

    let uri = new URIBuilder(
      ConfigurationManager.getProperty("TOKEN_API_HOST")
    );

    uri.path = `${ConfigurationManager.getProperty(
      "TOKEN_API_BASE_PATH"
    )}${GENERATE_TOKEN_PATH}`;

    let request = new Request(uri.toString(), configuration);
    return fetch(request).then((res) => res.json());
  }

  async refreshToken(refreshToken) {
    const [CLIENT_ID, CLIENT_SECRET] = await this.fetchCredentials();

    let headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    headers.append(
      "AppID",
      ConfigurationManager.getProperty("TOKEN_API_APP_ID")
    );

    let body = "";
    body += `refresh_token=${encodeURIComponent(refreshToken)}&`;
    body += `grant_type=${encodeURIComponent(REFRESH_GRANT_TYPE)}&`;
    body += `client_id=${encodeURIComponent(CLIENT_ID)}&`;
    body += `client_secret=${encodeURIComponent(CLIENT_SECRET)}`;

    let configuration = {};
    configuration.method = HttpMethod.POST;
    configuration.headers = headers;
    configuration.body = body;

    let uri = new URIBuilder(
      ConfigurationManager.getProperty("TOKEN_API_HOST")
    );
    uri.path = `${ConfigurationManager.getProperty(
      "TOKEN_API_BASE_PATH"
    )}${GENERATE_TOKEN_PATH}`;

    let request = new Request(uri.toString(), configuration);
    return fetch(request).then((res) => res.json());
  }
}

export default TokenClient;



// WEBPACK FOOTER //
// ./src/_clients/TokenClient.js